import type { FormShape } from "@suse-o11y/signal/form";
import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetMinMax } from "../../../widget-form/min-max";
import type { FormState as MinMaxFormState } from "../../../widget-form/min-max/form-state";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

interface RangeProps {
	range: FormShape<{
		min: MinMaxFormState;
		max: MinMaxFormState;
	}>;
}

export const Range: React.FC<RangeProps> = ({ range }) => (
	<Widget>
		<WidgetHeader className="grid-cols-[auto_1fr] uppercase" title="Y-axis Range">
			<FormFieldReset className="ml-auto" state={range} />
		</WidgetHeader>

		<WidgetBody card>
			<SettingsSectionGrid className="grid-cols-[auto_1fr]">
				<SettingsSectionFormField layout="horizontal" state={range.fields.min}>
					<FormLabel>Min</FormLabel>
					<WidgetMinMax name="dashboard-widget-y-axis-min" value={range.fields.min} />
				</SettingsSectionFormField>

				<SettingsSectionFormField layout="horizontal" state={range.fields.max}>
					<FormLabel>Max</FormLabel>

					<WidgetMinMax name="dashboard-widget-y-axis-max" value={range.fields.max} />
				</SettingsSectionFormField>
			</SettingsSectionGrid>
		</WidgetBody>
	</Widget>
);
